import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class MarkAlert extends Component {
  static propTypes = {
    message: PropTypes.string,
    onCloseAlert: PropTypes.func
  }

  handleCloseClick = () => {
    this.props.onCloseAlert()
  }

  render() {
    const { message } = this.props

    return (
      <div className="alert alert-danger">
        <button className="close" onClick={this.handleCloseClick}>
          ×
        </button>
        <span>{message}</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/MarkAlert.js